export default __webpack_public_path__ + "static/media/2218.c5bac7b3.png";